import PropTypes from "prop-types";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableSkeleton = ({
  rowCount = 5,
  columns = [],
  baseColor = "#e5e7eb",
  highlightColor = "#f3f4f6",
}) => {
  return (
    <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
      {Array(rowCount)
        .fill(0)
        .map((_, index) => (
          <tr key={index} className="border-b">
            {columns.map((col, colIndex) => (
              <td
                key={colIndex}
                className={`p-3 ${col.className || ""}`}
              >
                <Skeleton
                  width={col.width}
                  height={col.height}
                  circle={col.isCircle}
                  className={col.skeletonClassName}
                />
              </td>
            ))}
          </tr>
        ))}
    </SkeletonTheme>
  );
};

TableSkeleton.propTypes = {
  rowCount: PropTypes.number,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      isCircle: PropTypes.bool,
      className: PropTypes.string,
      skeletonClassName: PropTypes.string,
    })
  ),
  baseColor: PropTypes.string,
  highlightColor: PropTypes.string,
};

export default TableSkeleton;